<template>
  <v-list class="pa-4">
    <v-list-item
      v-for="language in languages"
      :key="language.iso"
      :data-qa="`language-${language.iso}`"
      width="260px"
      class="d-flex align-center justify-center cursor-pointer"
      @click="redirectToOtherLanguage(language)"
    >
      <v-img
        :src="language.flagImage.url"
        width="24px"
        :alt="language.iso"
        class="mr-4"
      />
      <v-list-item-title>
        {{ language.translations[`name_${language.iso}`] || language.name }}
      </v-list-item-title>
      <v-icon
        v-if="language.iso === currentLanguage"
        color="primary"
        size="24"
      >
        ui-icon-check
      </v-icon>
    </v-list-item>
  </v-list>
</template>

<script setup lang="ts">
import YaGoals from 'www/modules/YandexGoals'
import { Language } from 'common/types'

const currentLanguage = window.LANGUAGE_DATA.currentLanguage.iso

defineProps<{
  languages: Language[]
}>()

const instanceYaGoals = new YaGoals()

function redirectToOtherLanguage(language: Language) {
  const { currentLanguage, defaultLanguageIso } = window.LANGUAGE_DATA

  if (language.iso === currentLanguage.iso) {
    return
  }

  instanceYaGoals.send({ name: `languagesList__click-${language.iso}` })

  const { pathname, origin, search } = window.location
  const isoInUrl = new RegExp(`^/(${currentLanguage.iso})/`)

  if (defaultLanguageIso === language.iso) {
    window.location.href = `${origin}${pathname.replace(isoInUrl, '/')}${search}`

    return
  }

  if (defaultLanguageIso === currentLanguage.iso) {
    window.location.href = `${origin}/${language.iso}${pathname.replace(isoInUrl, '')}${search}`

    return
  }

  window.location.href = `${origin}/${language.iso}/${pathname.replace(isoInUrl, '')}${search}`
}
</script>
